import PropTypes from "prop-types";
import { useEffect, forwardRef } from "react";
import { Box } from "@mui/material";

const Page = forwardRef(({ children, title = "", ...other }, ref) => {
  useEffect(() => {
    if (title) {
      document.title = `${title} | Metalogix Support Portal`;
    }
  }, [title]);

  return (
    <Box ref={ref} {...other}>
      {children}
    </Box>
  );
});

Page.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
};

export default Page;
